export enum RequestURIs {
    GET_CONVERSATIONS = "GET_CONVERSATIONS",
    GET_CUSTOMER = "GET_CUSTOMER",
    GET_TOPICS = "GET_TOPICS",
    GET_WIDGETS = "GET_WIDGETS",
    GET_REPRESENTATIVES = "GET_REPRESENTATIVES",
    GET_REPRESENTATIVESETTINGS = "GET_REPRESENTATIVESETTINGS",
    GET_INCOMINGS="GET_INCOMINGS",
}